'use strict';
/*
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */

var twentyninetimes = twentyninetimes || {};

// Document ready
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    svg4everybody(); // Fix SVG spritemap in IE/Edge
  });

  twentyninetimes.loadMore.init();
  twentyninetimes.expandList.init();
  twentyninetimes.siteHeader.init();
  twentyninetimes.navigation.init();
  twentyninetimes.circlWord.init();
  twentyninetimes.hero.init();
  twentyninetimes.testimonials.init();
  twentyninetimes.pricingtable.init();
  // twentyninetimes.blogFilter.init();
  twentyninetimes.logowall.init();
  twentyninetimes.cookieSetter.checkAndSetCookie();
  twentyninetimes.languageSelector.init();
  twentyninetimes.iphone.init();
  twentyninetimes.quotes.init();
  twentyninetimes.sidebarColumns.init();
  twentyninetimes.youtubePlayer.init();
  twentyninetimes.banner.init();

  var inViewItems = document.querySelectorAll('.in-view-item');

  var circledWords = document.querySelectorAll('.animate-circle-word');
  if (inViewItems || inViewItems2) {
    var test = (item) => {
      // console.log(item);
      if (!item.classList.contains('visible')) {
        item.classList.add('visible');
      }
    };
    twentyninetimes.inView.init(inViewItems, test, -100);
  }

  if (circledWords) {
    var drawCircle = (item) => {
      if (!item.classList.contains('draw')) {
        item.classList.add('draw');
      }
    };
    twentyninetimes.inView.init(circledWords, drawCircle, -200);
  }
});
